import Main from './src/components/Main'

export default function App() {
  return <Main />
}
